import { OPEN_HOLIDAY_MODAL,ADD_HOLIDAY,GET_HOLIDAYS,REMOVE_HOLIDAY,SORT_HOLIDAY} from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = {
    list: [],
    status: 'ok',
    holidayModalOpen: false,
    sortDirection: 'ascending',
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OPEN_HOLIDAY_MODAL:
            return {
                ...state,
                holidayModalOpen: action.payload
            }

        case GET_HOLIDAYS:
            return {
                ...state,
                status: 'ok',
                list: action.payload
            }

        case ADD_HOLIDAY:
            if (action.payload) {
                if (action.payload.status === 200) {
                    
                    return {
                        ...state,
                        status: 'ok',
                        holidayModalOpen: false,
                        list: action.payload.body
                    }    
                } else {
                    return {
                        ...state,
                        holidayModalOpen: false,
                        status: action.payload.text
                    }
                }
            } else {
                return {
                    ...state,
                    holidayModalOpen: false,
                    status: 'Add Holiday failed'
                }
            }

        case REMOVE_HOLIDAY:
            if (action.payload) {
                return {
                    ...state,
                    status: 'ok',
                    list: action.payload
                }
            } else {
                return {
                    ...state,
                    status: 'Delete holiday failed'
                }
            }

            case SORT_HOLIDAY:
                let sorted = null;
                let sort_column = action.payload;
                let direction = 'ascending';
                if (state.sortColumn !== sort_column) {
                    console.log('Sorting by ' + sort_column);
                    sorted = _.sortBy(state.list, [sort_column]);
                } else {
                    sorted = state.list.reverse();
                    console.log(sorted);
                    direction = (state.sortDirection === 'ascending') ? 'descending' : 'ascending';
                    console.log('Sorting in ' + direction);
                }
    
                return {
                    ...state,
                    list: sorted,
                    sortColumn: sort_column,
                    sortDirection: direction
                }

        default:
            return state;
    }
};
